import { render, staticRenderFns } from "./Product_amh.vue?vue&type=template&id=a60588bc&scoped=true&"
import script from "./Product_amh.vue?vue&type=script&lang=js&"
export * from "./Product_amh.vue?vue&type=script&lang=js&"
import style0 from "./Product_amh.vue?vue&type=style&index=0&id=a60588bc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60588bc",
  null
  
)

export default component.exports